import { ArrowRight, ChevronDown, Pencil } from 'lucide-react'
import type { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import ProjectPlanLinks from '@/frontend/features/Fde/ProjectPlanLinks'
import { taskDate } from '@/frontend/features/Fde/projectTaskPresentation'
import type { ProjectPlan, ProjectPlanCopy } from '@/frontend/features/Fde/projectPlanTypes'

export default function ProjectPlanCheckpoint({ plan, copy, projectId, canManage, onEdit, historyAction }: {
  plan: ProjectPlan; copy: ProjectPlanCopy; projectId: string; canManage: boolean; onEdit: () => void; historyAction?: ReactNode
}) {
  return <section aria-label={copy.next_step} className="rounded-lg border border-border bg-muted/20 p-4">
    <div className="flex flex-wrap items-center justify-between gap-2">
      <h2 className="flex items-center gap-2 text-xs font-medium text-muted-foreground"><ArrowRight className="size-3.5" />{plan.next_step ? copy.next_step : copy.last_update}</h2>
      <div className="ml-auto flex items-center gap-1">{historyAction}{canManage && <Button variant="ghost" size="sm" className="h-7 gap-1.5 px-2 text-xs text-muted-foreground" onClick={onEdit}><Pencil className="size-3" />{copy.update}</Button>}</div>
    </div>
    <details className="group mt-1">
      <summary className="cursor-pointer list-none [&::-webkit-details-marker]:hidden">
        <div className="flex items-start justify-between gap-4">
          <p className="line-clamp-2 max-w-3xl text-base font-medium leading-6 tracking-tight group-open:line-clamp-none">{plan.next_step || plan.latest_update || copy.update_hint}</p>
          <ChevronDown className="mt-1 size-3.5 shrink-0 text-muted-foreground transition-transform group-open:rotate-180" />
        </div>
        {plan.checkpoint_at && <p className="mt-2 text-[11px] text-muted-foreground">{taskDate(plan.checkpoint_at.slice(0, 10))}{plan.updated_by_label && ` · ${plan.updated_by_label}`}</p>}
      </summary>
      <div className="mt-4 space-y-3 border-t border-border pt-4">
        {plan.next_step && plan.latest_update && <div><h3 className="mb-1 text-xs text-muted-foreground">{copy.last_update}</h3><p className="whitespace-pre-line text-sm leading-6">{plan.latest_update}</p></div>}
        {plan.health && plan.health !== 'on_track' && plan.health_reason && <p className="text-xs leading-5 text-amber-700 dark:text-amber-400">{plan.health_reason}</p>}
        <ProjectPlanLinks paths={plan.repo_paths} projectId={projectId} />
      </div>
    </details>
  </section>
}
